import { hasValue } from "../../../utils/functions.js";

import TableList from "../../sub-components/Generic/TableList/TableList.vue";
import DateField from "../../common/date-field";
import DecimalField from "../../common/decimal-field.vue";

const fieldClient = [
  { field: "Name", class: "text-left" },
  { field: "Identity", type: 'identity', class: "same-line text-left identity" },
];

export default {
  name: "DDA",
  components: {
    TableList,
    DateField,
    DecimalField
  },
  data() {
    return {
      idMerchant: null,
      headers: [
        { field: "IdTransaction", label: "Id da Transação", classHeader: 'text-left', classField: 'text-left' },
        { field: "DigitableLine", label: "Linha Digitável", classHeader: 'text-left', classField: 'text-left break-line' },
        { field: "IdentityMerchant", label: "Documento do Comerciante", type: 'identity', classHeader: 'text-left', classField: 'text-left' },
        { field: fieldClient, label: "Cliente", classHeader: 'text-left', classField: 'text-left' },
        { field: "CodeTransactionStatus", label: "Status", type:"StatusText", classHeader: 'text-left', classField: 'text-left' },
        { field: "DueDate", label: "Data de Vencimento", type:'date', classHeader: 'text-left', classField: 'text-left' },
        { field: "Amount", label: "Valor", type:'currency', classHeader: 'text-left', classField: 'text-left same-line' },
      ],
      headersProducts: [
        { field: "Id", label: "Id do Produto", classHeader: 'text-left', classField: 'text-left' },
        { field: "Description", label: "Descrição", classHeader: 'text-left', classField: 'text-left' },
        { field: "UnitPrice", label: "Preço Unitário", type: 'currency', classHeader: 'text-left', classField: 'text-left' },
        { field: "Quantity", label: "Quantidade", classHeader: 'text-left', classField: 'text-left' }
      ],
      selectedDDA: null,
      pageName: 'Consulta DDA',
      permissionIsAuthorize: 'BankSlip',
      countFilter: 0,
      itemList: [],
      filter: {
        DigitableLine: null,
        Identity: null
      },
      loading: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      modalTitle: "",
      additionalActions: [
        {authorization: 'List', name: 'Get', label: 'Visualizar', icon:'fas fa-eye mr-2'}
      ]
    };
  },

  methods: {
    OpenField(item, index, eventName) {
      this.validatedFieldForm = false;

      this.selectedDDA = item;

      this.isSeeing = true;
      this.modalTitle = "Detalhes do DDA";

      this.$bvModal.show("mMoreInfo");
    },

    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListDDA();
    },

    setDigitableLine(value){
      if(value.toString().length <= 48){
        this.filter.DigitableLine = value;
      }
      this.$forceUpdate()
    },

    ResetFilter() {
      this.filter = {
        DigitableLine: null,
        Identity: null
      };
      this.itemList = [];
    },

    GetParamsListDDA(deletePagination = false) {
      const regExp = new RegExp(/[\D]/g);
      let data = {
        ...this.pagination,
        "Object.Identity": hasValue(this.filter.Identity) ? this.filter.Identity : null,
        "Object.DigitableLine": hasValue(this.filter.DigitableLine) ? this.filter.DigitableLine.replace(regExp, '') : null
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },

    ListDDA() {
      this.countFilter = 0;
      //this.filter.DigitableLine = '74891121151937840116008281621006886690000000800';
      //74891121153897860116908281621014486860000000100
      Object.values(this.filter).map(value => { if (hasValue(value)) this.countFilter++ });
      if(this.countFilter > 0){
        this.loading = true;
        const params = this.GetParamsListDDA();
        this.$store.dispatch("ListDDA", { params: params })
          .then(response => {
            this.itemList = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          })
          .catch(error => {
            this.$makeToast("Um erro ocorreu ao listar os campos. Tente novamente.",
              "danger", "Erro ao listar", error);
          })
          .finally(() => (this.loading = false));
      }else{
        this.$makeToast("Não há filtro selecionado. Selecione algum filtro e tente novamente.",
              "warning", "Não há filtro selecionado.");
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/ConsultDDA/ConsultDDA.js